export default "__VITE_ASSET__DeB3vpU5__"